var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['relative', 'z-divider', _vm.getDirectionClasses, `bg-${_vm.color}`]},[(_vm.direction !== 'vertical')?_c('div',{staticClass:"z-divider--content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }